import React, { useEffect } from 'react';
import { css } from '@emotion/css';
import styled from '@emotion/styled';
import ModalLayout from '../structure/ModalLayout';
import Button from './Button';
import { color_shades_darkest } from '../../constants/colors';
import { useResponseVariableTester } from '../../hooks/useResponseVariableTester';
import ResponseVariableTesterUI from './ResponseVariableTesterUI';

const closeIcon = require('../../content/images/close_icon.svg');
const DOCS_URL = 'https://dev.azure.com/voicify/Voicify-Api/_wiki/wikis/Voicify-Api.wiki/39/Response-Variables?anchor=nesting-and-combining-features';

interface ResponseVariableTestModalProps {
    isVisible: boolean;
    onClose: () => void;
    initialText?: string;
}

const ResponseVariableTestModal: React.FC<ResponseVariableTestModalProps> = (props) => {
    const tester = useResponseVariableTester({ initialText: props.initialText });

    // Reset state when modal opens with new initial text
    useEffect(() => {
        if (props.isVisible) {
            tester.reset();
            if (props.initialText) {
                tester.setInputText(props.initialText);
            }
        }
    }, [props.isVisible, props.initialText]);

    return (
        <ModalLayout
            className={modalStyle}
            isVisible={props.isVisible}
            onClose={props.onClose}
            zIndex={1010}
        >
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <HeaderWrapper>
                    <h2>Test Response Variables</h2>
                    <Button
                        className="close-icon"
                        themes={['end-tight', 'icon']}
                        icon={closeIcon}
                        type="button"
                        onClick={props.onClose}
                    />
                </HeaderWrapper>

                <ResponseVariableTesterUI
                    {...tester}
                    docsUrl={DOCS_URL}
                />
            </ModalContainer>
        </ModalLayout>
    );
};

// Styles
const modalStyle = css`
    .modal-content {
        width: 900px;
        max-width: 95vw;
        max-height: 90vh;
        overflow-y: auto;
    }
`;

const ModalContainer = styled.div`
    padding: 24px;
`;

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    
    h2 {
        font-size: 20px;
        font-weight: 600;
        color: ${color_shades_darkest};
        margin: 0;
    }
`;

export default ResponseVariableTestModal;
